import React from 'react';
import { get, uniq } from 'lodash';
import PropTypes from 'prop-types';
import { Field } from '@bd/bdui-forms';

function MultiSelectField({
  options,
  className,
  field,
  label,
  required,
  getError,
  requiredMessage,
}) {
  return (
    <div className={className}>
      <label htmlFor="fileUpload" className="FormFileMultiple_label">{label}</label>
      <Field
        field={field}
        validate={value => {
          let error = null;

          if (!error && required) {
            error = !value || (Array.isArray(value) && value.length === 0)
              ? (requiredMessage || `${(label || '').replace(/[?!.*]/g, '')} is required.`)
              : null;
          }
          return error;
        }}
      >
        { fieldApi => {
          const { setValue } = fieldApi;

          return (
            <div>
              {
                options.map((option, i) => (
                  <div className="d-flex my-2" key={i.toString()}>
                    <input
                      type="checkbox"
                      value={get(option, 'value')}
                      onChange={e => {
                        const checked = e.target.checked;
                        const currentValue = fieldApi.value || [];
                        if (checked) {
                          setValue(uniq([...currentValue, option.value]));
                        } else {
                          setValue(currentValue.filter(v => v !== option.value));
                        }
                      }}
                      className="MultiSelect_input"
                    />
                    <span className="flex-fill ml-2 MultiSelect_text">
                      {get(option, 'label')}
                    </span>
                  </div>

                ))
              }

            </div>
          );
        }}
      </Field>
      <div className="invalid-feedback">
        {getError(field)}
      </div>
    </div>
  );
}

MultiSelectField.propTypes = {
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  className: PropTypes.string,
  field: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  requiredMessage: PropTypes.string,
  getError: PropTypes.func.isRequired,
};

MultiSelectField.defaultProps = {
  className: undefined,
  label: undefined,
  placeholder: undefined,
  required: false,
  requiredMessage: undefined,
  setValue: undefined,
  additionalText: undefined,
};

export default MultiSelectField;



// WEBPACK FOOTER //
// ./src/components/Forms/Fields/MultiSelect.js